import React from 'react';
import irelandApi from '../irelandApi';
import qs from 'qs';
import {
  GET_REWARD_FULFILLED,
  GET_REWARD_PENDING,
  GET_REWARD_REJECTED,
  GET_TRANSFER_VALUE_FULFILLED,
  GET_TRANSFER_VALUE_PENDING,
  GET_TRANSFER_VALUE_REJECTED,
  SAVE_TRANSFER_POINTS_FULFILLED,
  SAVE_TRANSFER_POINTS_PENDING,
  SAVE_TRANSFER_POINTS_REJECTED
} from '../reducers/rewardsReducer';
import { toast } from "react-toastify";
import ToastMessage from '../components/common/toast-message';
import store from '../store';

const url = '/api/rewards';

export const getRewards = () => (dispatch) => {
  dispatch({ type: GET_REWARD_PENDING });

  return irelandApi.get(url)
    .then((response) => {
      dispatch({ type: GET_REWARD_FULFILLED, payload: response.data });
    })
    .catch((error) => {
      dispatch({ type: GET_REWARD_REJECTED, payload: error.data });
    });
};

export const saveTransferPoints = (payload, pointValue) => {
  store.dispatch({ type: SAVE_TRANSFER_POINTS_PENDING });

  return irelandApi.post(`${url}/${payload.staff_member}/transfer_points`, { points: pointValue })
    .then((response) => {
      store.dispatch({ type: SAVE_TRANSFER_POINTS_FULFILLED, payload: response.data });
      toast.success(<ToastMessage iconStyle="success" message="Points has been transfered successfully" />);
    })
    .catch((error) => {
      if (error && error.response) {
        store.dispatch({ type: SAVE_TRANSFER_POINTS_REJECTED, payload: error.response.data });
        toast.error(<ToastMessage iconStyle="error" message={error.response.data.errors} />);
      }
    });
};

export const getTransferValue = (euro) => (dispatch) => {
  dispatch({ type: GET_TRANSFER_VALUE_PENDING });

  return irelandApi.get(`${url}/convert_transfer_currency_to_points?${qs.stringify({ reward: { euro } }, { encodeValuesOnly: true })}`)
    .then((response) => {
      dispatch({ type: GET_TRANSFER_VALUE_FULFILLED, payload: response.data });
    })
    .catch((error) => {
      if (error && error.response) {
        dispatch({ type: GET_TRANSFER_VALUE_REJECTED});
      }
    })
};



// WEBPACK FOOTER //
// ./src/actions/reward.js